import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { useRequestPasswordReset } from '../../api/hooks/useAuth.ts';
import {
  AuthCard,
  buttonClass,
  Field,
  FormError,
  FormNotice,
  inputClass,
} from '../../components/AuthCard.tsx';

export default function ForgotPassword() {
  const request = useRequestPasswordReset();
  const [email, setEmail] = useState('');

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    request.mutate(email);
  }

  // The API answers identically for known and unknown addresses, so the confirmation
  // says only that a mail was sent *if* the account exists — anything more would let a
  // caller probe which addresses are registered.
  if (request.isSuccess) {
    return (
      <AuthCard title="Check your inbox">
        <FormNotice
          message={`If ${email} has a planb account, we've sent it a link to choose a new password. The link is valid for 2 hours.`}
        />
        <Link className="block text-center text-sm text-blue-600 hover:underline" to="/login">
          Back to sign in
        </Link>
      </AuthCard>
    );
  }

  return (
    <AuthCard title="Reset your password">
      <form onSubmit={onSubmit}>
        <FormError message={request.error?.message} />
        <Field label="Email">
          <input
            className={inputClass}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </Field>
        <button className={buttonClass} type="submit" disabled={request.isPending}>
          {request.isPending ? 'Sending…' : 'Email me a reset link'}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-gray-500">
        Remembered it?{' '}
        <Link className="text-blue-600 hover:underline" to="/login">
          Sign in
        </Link>
      </p>
    </AuthCard>
  );
}
